wbApp.filter('phone', function () {
    return function (input) {
        return typeof input === 'string'
            ? input.replace(/\+?(\d{3})(\d{3})(\d{3})(\d{3})/, "+$1 $2 $3 $4")
            : '';
    };
});